import { ChatbotSession } from '../../../../../services/ai.service';
import { useIAChatHistoryStyles } from './IAChatHistory.styles';

type IAChatHistoryProps = {
  chatbotHistory: ChatbotSession[];
  isLoadingHistory: boolean;
  onLoadConversation: (chatbotId: number) => void;
};

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })} à ${date.toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
  })}`;
};

const IAChatHistory = ({
  chatbotHistory,
  isLoadingHistory,
  onLoadConversation,
}: IAChatHistoryProps) => {
  const classes = useIAChatHistoryStyles();

  if (isLoadingHistory) {
    return <p className={classes.emptyText}>Chargement...</p>;
  }

  if (chatbotHistory.length === 0) {
    return <p className={classes.emptyText}>Aucun historique</p>;
  }

  return (
    <div className={classes.historyList}>
      {chatbotHistory.map(session => (
        <button
          key={session.id}
          type="button"
          className={classes.historyItem}
          onClick={() => onLoadConversation(session.id)}>
          <div className={classes.historyItemTitle}>{session.title || '-'}</div>
          <div className={classes.historyItemDate}>{formatDate(session.createdAt)}</div>
        </button>
      ))}
    </div>
  );
};

export default IAChatHistory;
